<template>
  <b-container
    class="mb-5"
    fluid
  >
    <b-breadcrumb
      v-if="$route.meta.breadcrumb"
      :items="$route.meta.breadcrumb || []"
    />
    <herbicide-statistics />
  </b-container>
</template>

<script>
import { core } from '@/config/pluginInit'
import HerbicideStatistics from '@/components/dashboard/HerbicideStatistics.vue'

export default {
  name: 'SupervisorGraphHerbicideOnes',

  middleware: ['auth', 'supervisor'],

  components: {
    HerbicideStatistics
  },

  metaInfo () {
    return {
      title: 'Herbicides'
    }
  },

  mounted () {
    core.index()
  }

}
</script>
